import { AxiosError } from "axios";
import { msalInstance, protectedResources } from "common/config/auth.config";
import { HttpHeaderKey } from "common/enums/http-header.enum";
import { ApiResult } from "common/models/api-service/api-result.model";
import {
  GraphUserProfile,
  LeanGraphUser
} from "common/models/user-details.model";
import { BaseHTTPClient } from "./base-http-client.service";

export class GraphClient extends BaseHTTPClient {
  private static async getAccessToken(): Promise<string> {
    const acquireTokenResult = await msalInstance.acquireTokenSilent({
      scopes: protectedResources.graph.scopes
    });
    return acquireTokenResult.accessToken;
  }

  static async getCurrentUserProfile(): Promise<ApiResult<GraphUserProfile>> {
    try {
      const accessToken = await GraphClient.getAccessToken();
      const header = {
        [HttpHeaderKey.AUTHORIZATION]: `Bearer ${accessToken}`
      };

      const url = `${protectedResources.graph.endpoint}/me`;
      const data = await this.get<GraphUserProfile>(url, header);

      return data;
    } catch (e) {
      const axiosError: AxiosError = e as AxiosError;
      return new ApiResult<GraphUserProfile>(
        axiosError.response?.data as GraphUserProfile,
        axiosError.response?.status,
        axiosError.message
      );
    }
  }

  static async getCurrentUserAvatar(): Promise<ApiResult<Blob>> {
    try {
      const accessToken = await GraphClient.getAccessToken();
      const header = {
        [HttpHeaderKey.AUTHORIZATION]: `Bearer ${accessToken}`
      };

      const url = `${protectedResources.graph.endpoint}/me/photos/48x48/$value`;
      return await this.get<Blob>(url, header, "blob");
    } catch (e) {
      const axiosError: AxiosError = e as AxiosError;
      return new ApiResult(
        axiosError.response?.data,
        axiosError.response?.status,
        axiosError.message
      ) as unknown as any;
    }
  }

  static async getUserAvatar(id: string): Promise<ApiResult<Blob>> {
    try {
      const accessToken = await GraphClient.getAccessToken();
      const header = {
        [HttpHeaderKey.AUTHORIZATION]: `Bearer ${accessToken}`
      };

      const url = `${protectedResources.graph.endpoint}/users/${id}/photos/48x48/$value`;
      return await this.get<Blob>(url, header, "blob");
    } catch (e) {
      const axiosError: AxiosError = e as AxiosError;
      return new ApiResult(
        axiosError.response?.data,
        axiosError.response?.status,
        axiosError.message
      ) as unknown as any;
    }
  }

  static async searchUsers(key: string): Promise<LeanGraphUser[]> {
    try {
      const accessToken = await GraphClient.getAccessToken();
      const header = {
        [HttpHeaderKey.AUTHORIZATION]: `Bearer ${accessToken}`
      };
      const query = `$select=id,displayName,mail,userPrincipalName&$filter=startswith(displayName,'${key}') or startswith(mail,'${key}') or startswith(userPrincipalName,'${key}')&$top=5`;
      const url = `${protectedResources.graph.endpoint}/users?${query}`;
      const result = await this.get<any>(url, header);
      return result.value.value;
    } catch (e) {
      const axiosError: AxiosError = e as AxiosError;
      return new ApiResult(
        axiosError.response?.data,
        axiosError.response?.status,
        axiosError.message
      ) as unknown as any;
    }
  }
}
